import * as colors from 'material-ui/styles/colors';
import moment from 'moment';
import {Icon} from 'leaflet';

const iconGsm = new Icon({
    className: 'tech-marker',
    iconUrl: process.env.PUBLIC_URL + '/assets/status/flag_gsm_off.png',
    iconAnchor: [0, 75],
    iconSize: [55, 75],
    popupAnchor: [25, -75],
    labelAnchor: [0, 75],
});

const iconPark = new Icon({
    className: 'tech-marker',
    iconUrl: process.env.PUBLIC_URL + '/assets/status/flag_park_off.png',
    iconAnchor: [0, 75],
    iconSize: [55, 75],
    popupAnchor: [25, -75],
    labelAnchor: [0, 75],
});

const iconRun = new Icon({
    className: 'tech-marker',
    iconUrl: process.env.PUBLIC_URL + '/assets/status/flag_run_off.png',
    iconAnchor: [0, 75],
    iconSize: [55, 75],
    popupAnchor: [25, -75],
    labelAnchor: [0, 75],
});

const iconStop = new Icon({
    className: 'tech-marker',
    iconUrl: process.env.PUBLIC_URL + '/assets/status/flag_stop_off.png',
    iconAnchor: [0, 75],
    iconSize: [55, 75],
    popupAnchor: [25, -75],
    labelAnchor: [0, 75],
});

function getStatusColor(issue) {
    if (!issue) {
        return '';
    }
    switch (issue.statusID) {
        case 1:
            if (issue.assignedToID && issue.assignedToID > 0) {
                return '#2185d0';
            }
            return colors.grey600;
        case 2:
            return '#fbbd08';
        case 3:
            return '#21ba45';
        case 4:
            return '#f2711c';
        case 5:
            return '#db2828';
        case 6:
            return '#1b1c1d';
        default:
            return '#2185d0';
    }
}

function parseAvatarText(text) {
    let arrText = text.split(' ');
    if (arrText.length === 1) {
        return text.charAt(0);
    }

    if (arrText.length > 1) {
        return arrText[0].charAt(0) + arrText[1].charAt(0);
    }

    return '';
}

function parseUsername(firstname, lastname) {
    let fullName = '';

    if (firstname && firstname.split(' ').length > 1) {
        fullName = firstname;
    } else {
        fullName = `${firstname} ${lastname}`;
    }

    return fullName;
}

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
}

function deg2rad(deg) {
    return deg * (Math.PI / 180)
}

function parseTimeFromNow(time) {
    let unixNow = moment().unix();
    let unixTime = moment(time).unix();

    if ((unixNow - unixTime) > 86400) {
        return moment(time, "YYYY-MM-DD HH:mm:ss").format('DD-MM-YYYY HH:mm');
    }

    return moment(time, "YYYY-MM-DD HH:mm:ss").fromNow();
}

export {
    getStatusColor, parseAvatarText,
    parseUsername, getDistanceFromLatLonInKm,
    parseTimeFromNow,
    iconGsm, iconPark, iconRun, iconStop
};


// WEBPACK FOOTER //
// ./src/components/schedule/util/index.js